/* ══════════════════════════════════════════════════════════════════
   REYNA LUXURY INTERACTIONS — Premium Experience Enhancements
   Scroll reveals, word reveals, rule draws, counters, parallax, 
   magnetic buttons, Lenis smooth scroll
   ══════════════════════════════════════════════════════════════════ */
(function() {
  'use strict';

  /* ── LENIS SMOOTH SCROLL ── */
  function initLenis() {
    if (typeof Lenis === 'undefined') return;
    var lenis = new Lenis({
      duration: 1.4,
      easing: function(t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      orientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 0.85,
      touchMultiplier: 1.5,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }

  /* ── SCROLL REVEAL (.rev) ── */
  function initScrollReveal() {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.07 });
    document.querySelectorAll('.rev').forEach(function(el) { io.observe(el); });
  }

  /* ── STAGGERED WORD REVEAL ── */
  function wrapWords(el) {
    if (!el || el.dataset.wrapped) return;
    el.dataset.wrapped = '1';
    var nodes = Array.from(el.childNodes);
    el.innerHTML = '';
    nodes.forEach(function(node) {
      if (node.nodeType === 3) {
        var words = node.textContent.split(/(\s+)/);
        words.forEach(function(word) {
          if (!word.trim()) {
            el.appendChild(document.createTextNode(word));
          } else {
            var outer = document.createElement('span');
            outer.className = 'reveal-word';
            var inner = document.createElement('span');
            inner.className = 'reveal-word__inner';
            inner.textContent = word;
            outer.appendChild(inner);
            el.appendChild(outer);
          }
        });
      } else {
        el.appendChild(node);
      }
    });
  }

  function initWordReveals() {
    var targets = document.querySelectorAll(
      '.edit__head .hd, .occ__head .hd, .insta__head .hd, .vid-band__h, .wa-band__h'
    );
    targets.forEach(function(el) { wrapWords(el); });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('reveal-active');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    targets.forEach(function(el) { io.observe(el); });
  }

  /* ── GOLD RULE DRAW ── */
  function initRuleDraws() {
    var rules = document.querySelectorAll('.rule');
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('rule-drawn');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    rules.forEach(function(r) { io.observe(r); });
  }

  /* ── NUMBER COUNTERS ── */
  function countUp(el, target, duration) {
    var startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      var current = Math.floor(ease * target);
      el.textContent = current.toLocaleString('en-IN') + (el.dataset.suffix || '');
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target.toLocaleString('en-IN') + (el.dataset.suffix || '');
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var trustDesc = document.querySelectorAll('.ti__desc');
    trustDesc.forEach(function(el) {
      var text = el.textContent;
      if (text.indexOf('2,400') !== -1) {
        el.innerHTML = el.innerHTML.replace(
          '2,400+',
          '<span class="counter-animated" data-target="2400" data-suffix="+">2,400+</span>'
        );
      }
      var lbl = el.previousElementSibling;
      if (lbl && lbl.textContent.indexOf('25 Years') !== -1) {
        lbl.innerHTML = lbl.innerHTML.replace(
          '25 Years',
          '<span class="counter-animated" data-target="25">25</span> Years'
        );
      }
    });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var counter = e.target;
          var target = parseInt(counter.dataset.target);
          countUp(counter, target, 1800);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.counter-animated').forEach(function(el) { io.observe(el); });
  }

  /* ── MAGNETIC BUTTONS ── */
  function initMagneticButtons() {
    if (window.matchMedia('(hover: none)').matches) return;
    var btns = document.querySelectorAll('.btn--gold, .btn--line, .wa-band__btn');
    btns.forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        var r = btn.getBoundingClientRect();
        var cx = r.left + r.width / 2;
        var cy = r.top + r.height / 2;
        var dx = (e.clientX - cx) * 0.22;
        var dy = (e.clientY - cy) * 0.22;
        btn.style.transform = 'translate(' + dx + 'px, ' + dy + 'px)';
      });
      btn.addEventListener('mouseleave', function() {
        btn.style.transform = 'translate(0, 0)';
      });
    });
  }

  /* ── PARALLAX ── */
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var heroCopy = document.querySelector('.hero__copy');
    var vidBandGrad = document.querySelector('.vid-band__gradient');
    var ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var scrollY = window.pageYOffset;
          if (heroCopy) {
            var offset = scrollY * 0.12;
            heroCopy.style.transform = 'translateY(-' + offset + 'px)';
          }
          if (vidBandGrad) {
            var vbEl = document.querySelector('.vid-band');
            if (vbEl) {
              var vbTop = vbEl.getBoundingClientRect().top + scrollY;
              var vbOffset = (scrollY - vbTop) * 0.08;
              vidBandGrad.style.transform = 'translateY(' + vbOffset + 'px)';
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ── LUXURY REVEAL (section entries) ── */
  function initLuxuryReveal() {
    var targets = document.querySelectorAll('.trust, .wa-band, .occ__head, .edit__head');
    targets.forEach(function(el) { el.classList.add('luxury-reveal'); });
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });
    targets.forEach(function(el) { io.observe(el); });
  }

  /* ── Global cart-count sync (real-time across all headers) ──
     Intercepts all POSTs to /cart/add, /cart/change, /cart/update and
     refreshes every [data-cart-count] element on the page. Also exposes
     window.reynaRefreshCart() for manual refreshes. */
  function initCartCountSync() {
    function updateAll(count) {
      document.querySelectorAll('[data-cart-count], .acts-icons__count').forEach(function(el) {
        el.textContent = count;
      });
    }
    function refresh() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateAll(cart.item_count);
          document.dispatchEvent(new CustomEvent('reyna:cart-updated', { detail: cart }));
          return cart;
        })
        .catch(function() {});
    }
    window.reynaRefreshCart = refresh;

    // Wrap fetch to auto-refresh after any cart mutation
    if (window.fetch && !window.__reynaFetchWrapped) {
      var origFetch = window.fetch.bind(window);
      window.fetch = function(input, init) {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var res = origFetch(input, init);
        if (/\/cart\/(add|change|update|clear)(\.js)?/i.test(url)) {
          res.then(function() { setTimeout(refresh, 0); }).catch(function() {});
        }
        return res;
      };
      window.__reynaFetchWrapped = true;
    }

    // React to Horizon / theme cart events if dispatched
    ['cart:update', 'cart:refresh', 'cart:add'].forEach(function(evt) {
      document.addEventListener(evt, function() { refresh(); });
    });
  }

  /* ── INIT ALL ── */
  document.addEventListener('DOMContentLoaded', function() {
    initLenis();
    initScrollReveal();
    initWordReveals();
    initRuleDraws();
    initCounters();
    initMagneticButtons();
    initParallax();
    initLuxuryReveal();
    initCartCountSync();
  });
})();
